const Action = {
	create: 'create',
	add: 'add',
	remove: 'remove',
	stop: 'stop'
};

const PlaceHoldersBtn = {
	create: 'Create a scheduled move',
	edit: 'Edit scheduled move'
};

const ActionMessages = {
	add: { success: 'added to the schedule.', failed: '' },
	remove: { success: 'removed from the schedule.', failed: '' }
};

const FilterOptions = {
	allClients: 'All Clients',
	scheduleClients: 'Scheduled Clients'
};

export { Action, PlaceHoldersBtn, ActionMessages, FilterOptions };
